import constants from "../../commonUtils/constants";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: { keyword: "" },
  ExtCustomColumnQueriesList: constants.extraction.listInitialState,
  extCustomColumnQuery: null,
  openModal: false,
  errors: {},
  errorMessage: ""
};

const ExtCustomColumnQueries = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
      
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
      
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    
    case actionTypes.SET_OPEN_MODAL:
      return {
        ...state,
        openModal: action.payload,
        loading: false,
        extCustomColumnQuery: action.payload ? state.extCustomColumnQuery : null,
      };
    
    case actionTypes.SET_EXT_CUSTOM_COLUMN_QUERY:
      return {
        ...state,
        extCustomColumnQuery: action.payload,
      };
      
    case actionTypes.GET_EXT_CUSTOM_COLUMN_QUERIES_SUCCESS:
      return {
        ...state,
        loading: false,
        ExtCustomColumnQueriesList: action.payload,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.GET_EXT_CUSTOM_COLUMN_QUERIES_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch custom column queries"
      };

    case actionTypes.GET_EXT_CUSTOM_COLUMN_QUERY_SUCCESS:
      return {
        ...state,
        loading: false,
        extCustomColumnQuery: action.payload,
        openModal: true,
        errors: {},
        errorMessage: "",
      };
    
    case actionTypes.GET_EXT_CUSTOM_COLUMN_QUERY_FAILURE:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch custom column queries"
      };
      
    case actionTypes.CREATE_EXT_CUSTOM_COLUMN_QUERY_SUCCESS:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.CREATE_EXT_CUSTOM_COLUMN_QUERY_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || {},
        errorMessage: action.payload.message || "Failed to create custom column query"
      };
      
    case actionTypes.UPDATE_EXT_CUSTOM_COLUMN_QUERY_SUCCESS:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_CUSTOM_COLUMN_QUERY_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || {},
        errorMessage: action.payload.message || "Failed to update custom column query"
      };
    
    case actionTypes.UPDATE_EXT_CUSTOM_COLUMN_QUERIES_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_CUSTOM_COLUMN_QUERIES_ORDER_FAILURE:
      return {
        ...state,
      
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to update order"
      };
    
    case actionTypes.DELETE_EXT_CUSTOM_COLUMN_QUERY_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.DELETE_EXT_CUSTOM_COLUMN_QUERY_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to delete custom column query"
      };
      
    default:
      return state;
  }
};

export default ExtCustomColumnQueries;